import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import { onInputToUpperCase } from "utils";
import { MARFATIA_API_URL, getApiUrl } from "utils";

const DematUccForm = ({
  activeUserDetail,
  isLoading,
  handleBack,
  handleSubmit,
  showDemat = true,
}) => {
  const IS_DEFAULT_CHECKED = getApiUrl() === MARFATIA_API_URL ? true : false;
  const [initialValues, setInitialValues] = useState({
    ucc_account: IS_DEFAULT_CHECKED,
    demat_account: IS_DEFAULT_CHECKED,
    ucc_number: "",
    demat_number: "",
  });

  useEffect(() => {
    if (activeUserDetail?.ucc_code || activeUserDetail?.demat_account_no) {
      setInitialValues({
        demat_account:
          (!!activeUserDetail?.demat_account_no || IS_DEFAULT_CHECKED) &&
          showDemat,
        ucc_account: !!activeUserDetail?.ucc_code || IS_DEFAULT_CHECKED,
        demat_number: activeUserDetail?.demat_account_no,
        ucc_number: activeUserDetail?.ucc_code,
      });
    }
  }, [activeUserDetail, showDemat, IS_DEFAULT_CHECKED]);

  const handleValidate = (values) => {
    const errors = {};
    if (values.ucc_account) {
      if (!values.ucc_number) {
        errors.ucc_number = "Trading account number is required.";
      }
      if (/\s/.test(values.ucc_number)) {
        errors.ucc_number = "Trading account number cannot contain spaces.";
      }
    }
    if (values.demat_account) {
      if (!values.demat_number) {
        errors.demat_number = "Demat account number is required.";
      }
      if (/\s/.test(values.demat_number)) {
        errors.demat_number = "Demat account number cannot contain spaces.";
      }
    }
    return errors;
  };

  const onSubmit = (value) => {
    const payload = {
      ...value,
      demat_account: value.demat_account ? 1 : 0,
      ucc_account: value.ucc_account ? 1 : 0,
      demat_number: value.demat_account ? value.demat_number : "",
      ucc_number: value.ucc_account ? value.ucc_number : "",
    };
    console.log("payload", payload);
    handleSubmit(payload);
  };
  return (
    <>
      <Title title="Trading & Demat Account" />
      <div className="row">
        <div className="col-md-9">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validate={handleValidate}
                onSubmit={onSubmit}
              >
                {({ values, setFieldValue }) => (
                  <Form>
                    <div className="form-group my-2">
                      <div className="form-check my-1">
                        <Field
                          name="ucc_account"
                          className="form-check-input"
                          type="checkbox"
                          disabled={IS_DEFAULT_CHECKED}
                        />
                        <label className="form-check-label">
                          Trading Account
                        </label>
                      </div>
                    </div>
                    {showDemat && (
                      <div className="form-group my-2">
                        <div className="form-check my-1">
                          <Field
                            name="demat_account"
                            className="form-check-input"
                            type="checkbox"
                            disabled={IS_DEFAULT_CHECKED}
                          />
                          <label className="form-check-label">
                            Demat Account
                          </label>
                        </div>
                      </div>
                    )}
                    {values.ucc_account && (
                      <div className="form-group my-2">
                        <label className="my-1">Trading Account Number</label>
                        <Field
                          type="text"
                          name="ucc_number"
                          placeholder="Trading Account Number"
                          className="form-control"
                          onInput={onInputToUpperCase}
                        />
                        <ErrorMessage
                          name="ucc_number"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                    )}
                    {values.demat_account && (
                      <div className="form-group my-2">
                        <label className="my-1">Demat Account Number</label>
                        <Field
                          type="text"
                          name="demat_number"
                          placeholder="Demat Account Number"
                          className="form-control"
                          onInput={onInputToUpperCase}
                        />
                        <ErrorMessage
                          name="demat_number"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>
                    )}
                    <div className="d-flex form-group my-4">
                      <div className="mx-2">
                        <Button
                          type="button"
                          title="Back"
                          handleClick={() => handleBack()}
                          loading={isLoading}
                        />
                      </div>
                      <div className="mx-2">
                        <Button
                          title="Submit"
                          disabled={
                            !values.ucc_account && !values.demat_account
                          }
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DematUccForm;
